import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tw-merge";

const classMerge = (...input: ClassValue[]) => {
  return twMerge(clsx(input));
};

export { classMerge };
